import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import "swiper/swiper.scss";
import { client } from "../../../../App";
import { UserRoleEnum } from "../../../../helpers/enums";
import {
  IMPERSONATE,
  OPERATOR_RESEND_CONFIRMATION_EMAIL,
  OPERATOR_TRIGGER_RESET_PASSWORD
} from "../../../../helpers/mutations";
import { ImpersonateReq } from "../../../../models";
import { hideLoading, showLoading } from "../../../../reducers/app";
import {
  getUserProfileImpersonate,
  setImpersonateToken,
  setImpersonation,
} from "../../../../reducers/auth";
import Modal from "../../../common/Modal/Modal";
import "./DashboardImpersonationLinks.scss";

const ArrowLinkWithAction = ({handleOnClick, text}) => {
  return (
    <button className="service-card-container" onClick={handleOnClick} data-testid="ArrowLinkWithAction">
      <div className="service-card card">
        <span className="service-text">{text}</span>
        <i className="gc-icon-functional-arrow-right" aria-hidden="true"></i>
      </div>
    </button>
  )
}
const BoxUserManager = (props) => {
  const {t, emailVerified, links} = props;
  const selectionType = (type) => {
    props.setSelectedAction(type);
    props.setShowModal();
  }
  return (
    <div className="service-row">
      <h5 className="headline-bold-fs5 service-section-title">{t("dashboard.manager.utilities_managment")}</h5>
      <div className="cards">
        {links.map((x, index) => (
          <div key={index} className="grid-element">
            {x.type === "resend-email" && emailVerified ? null : (
              <>
                {x.action ?
                  <ArrowLinkWithAction handleOnClick={() => selectionType(x.type)} text={x.arrow}/>
                  :
                  <Link to={x.link} className="service-card-container">
                    <div className="service-card card">
                      <span className="service-text">{x.arrow}</span>
                      <i className="gc-icon-functional-arrow-right" aria-hidden="true"></i>
                      </div>
                  </Link>
                }
              </>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};
const DashboardImpersonationLinks = (props) => {
  const dispatch = useDispatch();
  const {impersonationActive, box1, box2} = props;
  const [show, setShow] = useState(false);
  const [selectedAction, setSelectedAction] = useState('');
  const [confirm, setConfirm] = useState(true);
  const [icon, setIcon] = useState("");
  const [error, setError] = useState(false);
  const [text, setText] = useState('');
  const [success, setSuccess] = useState(false);
  const searchUser = useSelector(state => state.auth.searchUser);

  const {
    role,
    emailVerified,
    impersonateToken = null,
    safoAccountId,
  } = props.searchProfileData;
  const impersonationMutate = (safoAccountId) =>
    client().mutate({
      mutation: IMPERSONATE,
      variables: ImpersonateReq(safoAccountId),
    });
  const handleActiveImpersonation = async (active) => {
    if (!impersonationActive) {
      await client().clearStore();
      if (!impersonateToken) {
        await impersonationMutate(safoAccountId)
          .then((data) => {
            const {token} = data.impersonate;
            return dispatch(setImpersonateToken(token));
          })
          .then(() => {
            dispatch(getUserProfileImpersonate());
            return dispatch(setImpersonation(active));
          })
          .catch((e) => console.log(e));
      } else {
        dispatch(getUserProfileImpersonate());
        dispatch(setImpersonation(active));
      }
    }
  };
  const {t} = useTranslation();
  useEffect(() => {
    if (confirm) {
      setIcon("gc-icon-functional-attention-2-col");
      setText(t("operator.modify_email.page.confirm"))
    }
    if (error) {
      setIcon("gc-icon-functional-close-circle-2-col");
      setText(t("operator.modify_email.page.error"));
    }
    if (success) {
      setIcon("gc-icon-functional-check-2-col");
      setText(t("operator.modify_email.page.success"));
    }
    if (selectedAction === 'change-password') {
      if (success) {
        setIcon("gc-icon-functional-check-2-col");
        setText(t("operator.modify_email.page.success"));
      } else if (error) {
        setIcon("gc-icon-functional-close-circle-2-col");
        setText(t("operator.modify_email.page.error"));
      } else {
        setIcon("gc-icon-functional-attention-2-col");
        setText(t("operator.modify_email.page.confirm_resend_password"));
      }
    }
  }, [selectedAction, confirm, error, success, searchUser, t])
  const resendEmail = () => {
    setShow(false);
    dispatch(showLoading());
    client().mutate({
      mutation: OPERATOR_RESEND_CONFIRMATION_EMAIL,
      variables: {
        req: {
          username: searchUser.email
        }
      }
    }).then(() => {
      dispatch(hideLoading());
      setShow(true);
      setSuccess(true);
      setConfirm(false);
    }).catch(e => {
      console.log(e);
      dispatch(hideLoading());
      setShow(true);
      setError(true);
      setConfirm(false);
    })
  }
  const resetPassword = () => {
    setShow(false);
    dispatch(showLoading());
    client().mutate({
      mutation: OPERATOR_TRIGGER_RESET_PASSWORD,
      variables: {req: {username: searchUser.email}}
    }).then(() => {
      dispatch(hideLoading());
      setConfirm(false);
      setShow(true);
      setSuccess(true);
    }).catch(e => {
      console.log(e);
      dispatch(hideLoading());
      setConfirm(false);
      setError(true);
      setShow(true);
    })
  }
  const setType = (type) => {
    setSelectedAction(type);
  }
  //2test.privato@yopmail.com
  return (
    <div
      className="DashboardImpersonationLinks DashboardYourServices"
      data-testid="DashboardImpersonationLinks"
    >
      <div className="headline-bold-fs4 dashboardImpersonationLinksTitle">{t("dashboard.manager.choose_operation")}</div>
      <div className="service-section">
        {(role === UserRoleEnum.OPERATOR ||
        role === UserRoleEnum.MANAGER ||
        role === UserRoleEnum.MUNICIPAL_OPERATOR)  ? (
            <BoxUserManager
              links={box2}
              t={t}
              emailVerified={emailVerified}
              setShowModal={() => setShow(true)}
              setSelectedAction={(type) => setType(type)}
            />

        ) : (
          <>
            <div className="service-row">
              <h5 className="headline-bold-fs5 service-section-title">{t("dashboard.manager.remote_controll")}</h5>
              <div className="cards">
                {box1.map((x, index) => {
                  if (x) {
                    return (
                      <div key={index} className="grid-element" onClick={() => handleActiveImpersonation(true)}>
                        <Link to={x.link} className="service-card-container">
                          <div className="service-card card">
                            <span className="service-text">{x.arrow}</span>
                            <i className="gc-icon-functional-arrow-right" aria-hidden="true"></i>
                            </div>
                        </Link>
                      </div>
                    );
                  }
                  return null;
                })}
              </div>
          </div>
            { searchUser?.authIssuer === 'COGNITO'  ?
              <BoxUserManager
                links={props.box2}
                t={t}
                emailVerified={emailVerified}
                setShowModal={() => setShow(true)}
                setSelectedAction={(type) => setType(type)}
              />
             : null}
            {/*<SwiperSlide>*/}
              {/*<div className="container-box-link">*/}
              {/*  <div*/}
              {/*    className="box-link"*/}
              {/*    key="paperino"*/}
              {/*    style={{position: "relative"}}*/}
              {/*  >*/}
              {/*    <h1>*/}
              {/*      <span>#</span>*/}
              {/*      {t("dashboard.manager.other_operations")}*/}
              {/*    </h1>*/}

              {/*    /!*{box3.map((x, index) => (*!/*/}
              {/*    /!*  <div key={index} className="box-arrow-item">*!/*/}
              {/*    /!*    <ArrowLink to={x.link}>{x.arrow}</ArrowLink>*!/*/}
              {/*    /!*  </div>*!/*/}
              {/*    /!*))}*!/*/}
              {/*  </div>*/}
              {/*</div>*/}
            {/*</SwiperSlide>*/}
          </>
        )}
      </div>
      <Modal
        show={show}
        onClose={() => setShow(false)}
        icon={icon}
        descriptionClass={"paragraph-main-fs8"}
        content={text}
        >
          {confirm ?
            (
              <div className="modal-lang--cta">
                {
                  selectedAction === 'change-password' ?
                    <button onClick={() => resetPassword()} className="btn btn-primary">
                      {t("operator.modify_email.page.btn_confirm_ok")}
                    </button>
                    :
                    <button onClick={() => resendEmail()} className="btn btn-primary">
                      {t("operator.modify_email.page.btn_confirm_ok")}
                    </button>
                }
                <button onClick={() => {
                  setShow(false);
                  setConfirm(true);
                }} className="btn btn-primary">
                  {t("operator.modify_email.page.btn_confirm_ko")}
                </button>
              </div>
            ) : (
              <div className="modal-lang--cta">
                <button onClick={() => {
                  setShow(false)
                  setConfirm(true);
                  setSuccess(false)
                  setError(false);
                }} className="btn btn-primary">
                  {error ? t("operator.modify_email.page.btn_error") : t("operator.modify_email.page.btn_success")}
                </button>
              </div>
            )
          }
        </Modal>
    </div>
  );
};
export default DashboardImpersonationLinks;
